import { useNavigation } from 'hooks/navigation';
import { NarrowContainer } from 'components/Projects/CreateAndImport';
import { StickyFooter } from 'components/UI/StickyFooter';
import { Typography } from 'components/UI/Typography';
import { Flex } from 'components/UI/Flex';
import { Spacer } from 'components/UI/Spacer';
import { Svgs } from 'environment';
import { LanguageType } from 'types/index';
import { useLanguage } from 'features/hooks/useLanguage';

const DICTIONARY = {
	[LanguageType.English]: {
		projectRequestSent: 'Project Request Sent',
		approvalNotification: 'Your project request has been sent to an admin for approval',
		backToHome: 'Back to home'
	},
	[LanguageType.Norwegian]: {
		projectRequestSent: 'Prosjektforespørsel sendt',
		approvalNotification:
			'Prosjektforespørselen din er sendt til en administrator for godkjenning.',
		backToHome: 'Til prosjektoversikt'
	}
};

export function AdminApprovalSuccess() {
	const { navigate } = useNavigation();
	const language = useLanguage();
	const dictionary = DICTIONARY[language];

	return (
		<>
			<NarrowContainer>
				<Flex align={a => a.center} column>
					<Svgs.ProjectComplete style={{ minHeight: 240 }} />
					<Spacer size={s => s.s} />
					<Typography.H5 alignCenter>{dictionary.projectRequestSent}</Typography.H5>
					<Spacer size={s => s.xs} />
					<Typography.Paragraph alignCenter>
						{dictionary.approvalNotification}
					</Typography.Paragraph>
				</Flex>
			</NarrowContainer>

			<StickyFooter
				primary={{
					label: dictionary.backToHome,
					onClick: () => navigate('/')
				}}
				maxWidth={65.2}
			/>
		</>
	);
}
